export default {
  data() {
    return {
      unassigned_packages: [],
      producers_organizations: null,
      exporter_process_crop_categories: [],
      exporter_process_crop_varieties: [],
      exporter_process_crop_sizes: [],
      exporter_process_crop_packages: [],
      exporter_process_brands: [],
      packages: [],
      comment: "",
      pg_code: "",
      thermo_code: "",
      grouped_at: null,
    };
  },
  computed: {
    new_assigned_packages: function () {
      return this.packages.filter(
        (package_item) => package_item.from_stock && package_item.id && !package_item._destroy
      );
    },
    new_assigned_package_ids: function () {
      return this.new_assigned_packages.map((package_item) => package_item.id);
    },
    empty_to_assign_slots: function () {
      return this.packages.filter(
        (package_item) => package_item.from_stock && package_item.id == null
      ).length;
    },
    can_assign_other_package: function () {
      return this.toAssignPackages().length - this.empty_to_assign_slots > 0;
    },
  },
  methods: {
    maxQuantityToAssign: function (package_item) {
      return this.unassigned_packages.find(option => option.id = package_item.id)?.quantity ?? 1;
    },
    addInitialPackage: function () {
      // if (this.unassigned_packages.length > 0)
        this.addFromStockPackage();
      // else this.addPackage();
    },
    emptyNewPackage: function () {
      return {
        producer_id: this.default_producer_id,
        organization_id: this.default_organization_id,
        exporter_process_crop_package_id: this.hasOneItem(
          this.exporter_process_crop_packages
        ),
        exporter_process_crop_category_id: this.hasOneItem(
          this.exporter_process_crop_categories
        ),
        exporter_process_crop_variety_id: this.hasOneItem(
          this.exporter_process_crop_varieties
        ),
        exporter_process_crop_size_id: this.hasOneItem(
          this.exporter_process_crop_sizes
        ),
        exporter_process_brand_id: this.hasOneItem(
          this.exporter_process_brands
        ),
        quantity: null,
        from_stock: false,
        from_form: true, // quiere decir que ha sido creado en el formulario, pero todavia no se procesa en rails
      };
    },
    addPackage: function () {
      let new_package = this.emptyNewPackage();
      this.packages.push(new_package);
    },
    changeToNewPackage: function (package_item) {
      const index = this.packages.indexOf(package_item);
      this.packages[index] = this.emptyNewPackage();
    },
    addFromStockPackage: function () {
      let new_package = { id: null, from_stock: true, from_form: true };
      this.packages.push(new_package);
    },
    toAssignPackages: function (actual_package = null) {
      let isActualPackage = (package_item) =>
        actual_package ? package_item.id == actual_package?.id : false;
      return this.unassigned_packages.filter(
        (package_item) =>
          !this.new_assigned_package_ids.includes(package_item.id) ||
          isActualPackage(package_item)
      );
    },
    validPackage: function (package_item) {
      if (package_item.from_stock) return Boolean(package_item.id);

      return (
        Boolean(package_item.exporter_process_crop_package_id) &&
        Boolean(package_item.exporter_process_crop_category_id) &&
        Boolean(package_item.exporter_process_crop_variety_id) &&
        Boolean(package_item.exporter_process_crop_size_id) &&
        Boolean(package_item.exporter_process_brand_id) &&
        Number(package_item.quantity) > 0 &&
        (Boolean(package_item.producer_id) ||
          Boolean(package_item.organization_id))
      );
    },
  }
}